import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Route, Marker, Snackbar } from 'sm-react-components';

import { Map } from 'sm-react-components';

const styles = {
    noLogs: {
        padding: '10px'
    },
    content: {
        height: '300px'
    },
    snackbarRoot: {
        position: 'absolute',
        top: '-20%'
    }
};

class RequestsMap extends Component {
    state = {
        status: undefined,
        processing_time: undefined,
        routes: undefined,
        missing: undefined,
        selected: undefined,
        snackbarOpen: false
    }

    handleSelectPoi = (poi, id) => {
        const { onPoiSelected } = this.props;
        this.setState({
            selected: id
        });
        onPoiSelected && onPoiSelected(poi);
    }
    handleSelectRoute = (route) => {
        const { onRouteSelected } = this.props;
        this.setState({
            selected: route.vehicle_id
        });
        onRouteSelected && onRouteSelected(route);
    }

    generateSuccessState = (payload, response) => {
        // Map all services
        const servicesMap = {};
        const vehiclesMap = {};
        const pickupsMap = {};
        const missingList = [];

        payload.services.forEach((service) => {
            if (service.pickups && service.pickups.length > 0) {
                // Add each pickup to the map
                service.pickups.forEach((pickup, idx) => {
                    const id = pickup.id || `pickup-${service.id}-${idx}`;
                    pickupsMap[id] = pickup;
                });
            }
            servicesMap[service.id] = { location: service.location, duration: service.duration, pickups: service.pickups, timewindows: service.timewindows, size: service.size };
        });
        payload.vehicles.forEach((vehicle) =>
            vehiclesMap[vehicle.id] = { start: vehicle.start, end: vehicle.end }
        );

        const { missing } = response.solution;
        missing.forEach(service => {
            const newMissing = { ...servicesMap[service.id], id: service.id };

            // Add pickups to the missing list
            if (servicesMap[service.id].pickups) {
                newMissing['type'] = 'delivery';
                servicesMap[service.id].pickups.forEach((pickup, idx) => {
                    const id = pickup.id || `pickup-${service.id}-${idx}`;
                    missingList.push({ ...pickupsMap[id], id, type: 'pickup' });
                });
            }
            missingList.push(newMissing);
        });
        // Extend information for routes
        const { routes } = response.solution;
        const extendedRoutes = [];

        routes.forEach((route) => {
            let distance = 0;
            const vehicle = vehiclesMap[route.vehicle_id];
            const steps = route.steps.map((service) => {
                if (service.distance) {
                    distance += service.distance;
                }
                if (service.type === 'stop') {
                    return { ...service, ...servicesMap[service.id], vehicle: route.vehicle_id, ...{ type: (servicesMap[service.id].pickups && 'delivery') || service.type } };
                }
                else if (service.type === 'pickup') {
                    const pickup = pickupsMap[service.id];
                    return { ...service, location: pickup.location, vehicle: route.vehicle_id };
                }
                else if (service.type === 'start') {
                    return { ...service, location: vehicle.start, vehicle: route.vehicle_id };
                }
                else if (service.type === 'end') {
                    return { ...service, location: vehicle.end, vehicle: route.vehicle_id };
                }
                return undefined;
            });
            extendedRoutes.push({
                vehicle_id: route.vehicle_id,
                vehicle,
                geometry: route.geometry,
                steps,
                distance
            });
        });
        this.setState({
            routes: extendedRoutes,
            missing: missingList,
        });
    }

    generateErrorState = (payload, response) => {
        this.setState({
            routes: undefined,
        });
    }

    generateRoutes = (request) => {
        const { payload, response } = request;

        if (!response) {
            this.generateErrorState(payload, response);
        }
        else if (response.status === 'success') {
            this.generateSuccessState(payload, response);
        }
    }
    componentDidMount() {
        const { request } = this.props;
        if (request) {
            // Generate the routes object
            this.generateRoutes(request);
            const { key, response } = request;
            if (response && key.testMode) {
                this.setState({ warning: `Test mode is enabled for this key.`, snackbarOpen: true, error: undefined });
            }
            else if (response) {
                response.solution.missing.length > 0 && this.setState({ warning: `${response.solution.missing.length} service(s) not assigned`, snackbarOpen: true, error: undefined });
            }
            // Check the status
            else if (key) {
                key.status === 'failed' && this.setState({ error: key.message, snackbarOpen: true, warning: undefined });
            }
        }
    }

    render() {
        const { routes, selected, error, snackbarOpen, warning, missing } = this.state;
        const { height, classes } = this.props;
        const message = error ? error : warning;
        const variant = error ? 'error' : 'warning';
        return (
            <React.Fragment>
                <div style={{ position: 'relative' }}>
                    <Snackbar
                        variant={variant}
                        open={(snackbarOpen)}
                        onClose={() => this.setState({ snackbarOpen: false })}
                        horizontal="center"
                        vertical="top"
                        message={message}
                        classes={{ anchorOriginTopCenter: classes.snackbarRoot }}
                    />
                    <Map height={height || 540}>
                        {routes && routes.map((route, idx) => {
                            const routeSelected = route.vehicle_id === selected;
                            const routeKeySimple = 'route-' + route.vehicle_id;
                            const routeKey = 'route-' + route.vehicle_id + (routeSelected ? '-selected' : '');
                            return (
                                <Route
                                    key={routeKey}
                                    color={idx + 1}
                                    path={route.geometry}
                                    selected={routeSelected}
                                    onClick={() => this.handleSelectRoute(route)}
                                >
                                    {route.steps.map((step) => {
                                        const id = step.id === undefined ? routeKeySimple + '-' + step.type : step.id;
                                        const poiSelected = id === selected;
                                        const poiKey = routeKeySimple + '-poi-' + id + (poiSelected ? '-selected' : '');
                                        return step.location && (
                                            <Marker
                                                onClick={() => this.handleSelectPoi(step, id)}
                                                key={poiKey}
                                                lat={step.location.lat}
                                                lng={step.location.lng}
                                                selected={poiSelected}
                                                {...step.type !== 'stop' ? { kind: step.type } : {}}
                                            />);
                                    })}
                                </Route>
                            );
                        })
                        }
                        {missing && missing.map((item, index) => {
                            const poiKey = 'missing-poi-' + index;
                            const poiSelected = poiKey === selected;
                            return (
                                <Marker
                                    key={poiKey}
                                    onClick={() => this.handleSelectPoi(item, poiKey)}
                                    lat={item.location.lat}
                                    lng={item.location.lng}
                                    selected={poiSelected}
                                    kind={item.type}
                                />
                            );
                        })}

                    </Map>
                </div>
            </React.Fragment >
        );
    }
}

export default withStyles(styles)(RequestsMap);